import { render, staticRenderFns } from "./internship-contact.vue?vue&type=template&id=2fcfa94d&"
import script from "./internship-contact.vue?vue&type=script&lang=js&"
export * from "./internship-contact.vue?vue&type=script&lang=js&"
import style0 from "./internship-contact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "internship-contact.vue"
export default component.exports